export default __webpack_public_path__ + "static/media/home-header-video-thumb.cc7beaef.jpg";